<template>
  <div>
    <!--    已付款导出 export3-->
    <div>
      <el-form @submit.native.prevent inline label-width="100px">
<!--        <el-form-item label="订单号:">-->
<!--          <el-input v-model="searchData.ChildOrderNo" placeholder="子订单号"></el-input>-->
<!--        </el-form-item>-->
        <el-form-item label="营客通订单号">
          <el-input v-model="searchData.ChildOrderNo" placeholder="营客通订单号"></el-input>
        </el-form-item>
        <el-form-item label="商品名称:">
          <el-input v-model="searchData.SkuName" placeholder="请输入商品名称"></el-input>
        </el-form-item>
        <el-form-item label="分销账号:">
          <el-input v-model="searchData.ChannelBusiness" placeholder="请输入分销账号"></el-input>
        </el-form-item>
        <el-form-item label="下单用户:">
          <el-input v-model="searchData.DistributorUserName" placeholder="下单用户"></el-input>
        </el-form-item>
          <el-form-item label="订单状态">
            <el-select v-model="searchData.Status" placeholder="请选择">
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        <!--        <el-col :span="6">-->
        <!--          <el-form-item label="供应商" prop="SupplierId">-->
        <!--            <el-select v-model="searchData.SupplierId" filterable remote placeholder="请选择 / 可搜索"-->
        <!--                       :remote-method="querySupplier" style="width:100%">-->
        <!--              <el-option v-for="item in supplier" :key="item.id" :label="item.proSupplierName" :value="item.id">-->
        <!--              </el-option>-->
        <!--            </el-select>-->
        <!--          </el-form-item>-->
        <!--        </el-col>-->
        <!--        <el-form-item label="支付时间：">-->
        <!--          <el-date-picker v-model="valueTime" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"-->
        <!--                          range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"-->
        <!--                          @change="handlePicker"-->
        <!--                          style="width:100%">-->
        <!--          </el-date-picker>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="采购单号:">-->
        <!--          <el-input v-model="searchData.orderPurchaseNo" placeholder="子订单号"></el-input>-->
        <!--        </el-form-item>-->
        <el-form-item label="供应商选择">
          <el-select @change="getOneData" style="margin-left:10px;margin-bottom:10px;" clearable
                     v-model="searchData.ResellerId" placeholder="请选择供应商">
            <el-option
                v-for="item in supplierList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div style="display: flex;margin: 15px;">
        <el-button type="primary" @click="searchFun">查询</el-button>
        <el-button @click="resetFun">重置</el-button>
        <el-button type="primary" v-if="isExportShow" @click="export3">导出</el-button>
        <!--          <toolbar style="margin-left:10px ;" :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>-->
      </div>
      <el-table @selection-change="selectCurrentRow" :data="tableList" highlight-current-row
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
                style="width: 100%" border>
        <el-table-column type="selection" width="50" fixed align="center"></el-table-column>
        <el-table-column prop="distributorCompanyName" label="下单账号" width="300" align="center">
          <!--        <template slot-scope="scope">-->
          <!--          <div>{{ scope.row.orderNo }}</div>-->
          <!--          <p></p>-->
          <!--          &lt;!&ndash;            platformOrderType 1  京东开普勒&ndash;&gt;-->
          <!--          <el-tag size="mini" v-if="scope.row.platformType === 1 && scope.row.platformOrder" type="danger">京东订单-->
          <!--            {{ scope.row.receivingName }}已下单: {{ scope.row.platformOrder }}-->
          <!--          </el-tag>-->
          <!--          <p>-->
          <!--            <el-tag size="mini" v-if="scope.row.isHaveAfterOrder && scope.row.outOrderNo" effect="dark" type="danger">外部订单有售后订单</el-tag>-->
          <!--          </p>-->
          <!--        </template>-->
        </el-table-column>
        <el-table-column label="营客通订单号" prop="childOrderNo" width="150" align="center">
          <!--        <template slot-scope="scope">-->
          <!--          <span v-if="Array.isArray(scope.row.orderPurchases) && scope.row.orderPurchases.length > 0">{{-->
          <!--              scope.row.orderPurchases[0].orderPurchaseNo-->
          <!--            }}</span>-->

          <!--          &lt;!&ndash;            {{ scope.row.orderPurchases[0]?.orderPurchaseNo }}&ndash;&gt;-->

          <!--        </template>-->
        </el-table-column>
        <el-table-column label="订单状态" align="center" min-width="200">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == '10'">待支付</el-tag>
            <el-tag v-if="scope.row.status == '20'">备货中(待发货)</el-tag>
            <el-tag v-if="scope.row.status == '30'">待收货(已发货)</el-tag>
            <el-tag v-if="scope.row.status == '40'">已收货</el-tag>
            <el-tag v-if="scope.row.status == '50'">已完成</el-tag>
            <el-tag v-if="scope.row.status == '60'">已取消</el-tag>
            <el-tag v-if="scope.row.status == '70'">已关闭</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="childOrderNo" label="外部订单号" width="200" align="center"></el-table-column>
        <el-table-column prop="modelCode" label="型号" width="200" align="center"></el-table-column>
        <el-table-column prop='skuName' label="商品名称" width="250" align="center">
          <!--        <template slot-scope="scope">-->
          <!--          <span style="display: inline-block;margin-right:10px;"> {{-->
          <!--              scope.row.orderItems &&-->
          <!--              scope.row.orderItems[0] && scope.row.orderItems[0].productSkuName-->
          <!--            }}</span>-->
          <!--        </template>-->
        </el-table-column>
        <el-table-column prop='skuSpecs' label="商品规格" align="center" width="120">
          <!--        <template slot-scope="scope">-->
          <!--          <span style="display: inline-block;margin-right:10px;">{{-->
          <!--              scope.row.orderItems && scope.row.orderItems[0] &&-->
          <!--              scope.row.orderItems[0].productSpecExt ? scope.row.orderItems[0].productSpecExt : scope.row.orderItems[0].productSpec-->
          <!--            }}</span>-->
          <!--        </template>-->
        </el-table-column>
        <el-table-column prop="skuNumber" label="购买数量" align="center" width="120">
          <!--        <template slot-scope="scope">-->
          <!--          <span style="display: inline-block;margin-right:10px;">{{-->
          <!--              scope.row.orderItems && scope.row.orderItems[0] &&-->
          <!--              scope.row.orderItems[0].productSpecExt ? scope.row.orderItems[0].productSpecExt : scope.row.orderItems[0].productSpec-->
          <!--            }}</span>-->
          <!--        </template>-->
        </el-table-column>
        <el-table-column prop='skuPrice' label="分销价格" width="150" align="center">
          <!--        <template slot-scope="scope">-->
          <!--          <span style="display: inline-block;margin-right:10px;"> {{-->
          <!--              scope.row.orderPurchases && scope.row.orderPurchases[0] && scope.row.orderPurchases[0].productSupplierName-->
          <!--            }}</span>-->
          <!--        </template>-->
        </el-table-column>
        <el-table-column prop="purchasePrice" label="采购价格" width="150" align="center">
          <!--        <template slot-scope="scope">-->
          <!--          {{-->
          <!--            scope.row.orderPurchases && scope.row.orderPurchases[0] && scope.row.orderPurchases[0].productSupplierName-->
          <!--          }}-->
          <!--        </template>-->
        </el-table-column>
        <el-table-column prop="purchaseAmount" label="采购合计" width="120" align="center">
        </el-table-column>
        <el-table-column prop="stock" label="收货人信息" width="120" align="center">
          <template slot-scope="scope">
            {{ scope.row.receiverName }}
            {{ scope.row.receiverPhone }}
            {{ scope.row.receiverAddress }}
          </template>
        </el-table-column>
        <!--      <el-table-column prop="creationTime" label="数量" width="200" align="center">-->
        <!--        <template slot-scope="scope">-->
        <!--          <span style="display: inline-block;margin-right:10px;"> {{-->
        <!--              scope.row.orderItems &&-->
        <!--              scope.row.orderItems[0] && scope.row.orderItems[0].quantity-->
        <!--            }}</span>-->
        <!--        </template>-->
        <!--      </el-table-column>-->
        <!--      <el-table-column prop="payTotalAccount" label="订单金额" width="200" align="center">-->
        <!--          <template slot-scope="scope">-->
        <!--                        <span style="display: inline-block;margin-right:10px;"> {{-->
        <!--                            (scope.row.orderItems && scope.row.orderItems[0] && scope.row.orderItems[0].unitPrice)  *-->
        <!--                            (scope.row.orderItems &&    scope.row.orderItems[0] && scope.row.orderItems[0].quantity)-->
        <!--                          }}</span>-->
        <!--          </template>-->
        <!--      </el-table-column>-->
        <!--        <el-table-column prop="lastModificationTime" label="优惠信息" width="200" align="center"></el-table-column>-->
        <el-table-column prop="payTime" label="支付时间" width="200" align="center"></el-table-column>
<!--        <el-table-column fixed="right" prop="payTotalAccount" label="操作" width="200" align="center">-->
<!--          <template>-->
<!--            <el-button prop="payTime" type="primary" size="medium">采购付款</el-button>-->
<!--          </template>-->
<!--        </el-table-column>-->
      </el-table>
      <el-pagination class="pagination" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
                     @current-change="handleCurrentChange" :total="total"
                     :page-sizes="[10, 20, 30, 40, 50, 100]"></el-pagination>
    </div>
  </div>
</template>
<script>
import Toolbar from "../../../../components/Toolbar.vue";
import {getButtonList} from "../../../../promissionRouter";
import {
  DistributionHasPaidOrderList,
  DistributionPayInfo, ExportDistributionHasPaidOrderList,
  ExportDistributionUnPaidOrderList,
  GetAllReseller
} from "../../../../api/api";

export default {
  components: {Toolbar},
  data() {
    return {
      supplierList: [],
      options: [{
        value: '10',
        label: '待支付'
      }, {
        value: '20',
        label: '备货中(待发货)'
      }, {
        value: '30',
        label: '待收货(已发货)'
      }, {
        value: '40',
        label: '已收货'
      }, {
        value: '50',
        label: '已完成'
      }, {
        value: '60',
        label: '已取消'
      }, {
        value: '70',
        label: '已关闭'
      }],
      isExportShow: false,
      total: null,
      tableList: [],
      valueTime: [],
      searchData: {
        ResellerId:null,
        PageIndex: 1, //页码
        PageSize: 10, //页长
        ChildOrderNo: null,
        SkuName: null,
        DistributorUserName: '',
        ChannelBusiness: '',
        StartPayTime: null,
        EndPayTime: null,
        receivingName: null,
        Status: null,
      },
    }
  },
  mounted() {
    console.log(1)
    let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    var buttonList = getButtonList(this.$route.path, routers);
    if (buttonList && buttonList.length > 0) {
      const toolBarButtonList = buttonList.filter((item) => {
        return item.buttonShow === 10;
      });
      console.log('buttonList', buttonList);
      this.buttonList_toolBar = toolBarButtonList;
      this.buttonList_toolBar && this.buttonList_toolBar.forEach((item) => {
        if (item.buttonFunc === 'export3') {
          this.isExportShow = true;
        }
      })
      // const tableButtonList = buttonList.filter((item) => {
      //   return item.buttonShow === 20;
      // });
      // this.buttonList_table = tableButtonList;
    }
  },
  created() {
    this.getList()
    // this.getInfo()
    this.getDistributorList();
  },
  methods: {
    async getDistributorList() {
      let res = await GetAllReseller({PageIndex: 1, PageSize: 50});
      console.log('getDistributorList', res);
      if (res.data.success) {
        if (res.data.result.items.length > 0) {
          res.data.result.items.forEach((item) => {
            this.supplierList.push({id: item.id, name: item.name})
          })
          // if (this.supplierList.length > 0) {
          //   this.searchData.ResellerId = this.supplierList[0].id
          //   await this.getList()
          // }
        }
      } else {
        this.$message.error(res.data.error.message)
      }
    },
    getOneData(){
      this.getList();
    },
    // async getInfo(){
    //  let res = await DistributionPayInfo();
    // },
    async getList() {
      let res = await DistributionHasPaidOrderList(this.searchData);
      if (res.data.success) {
        if (res.data.result.data.data) {
          this.tableList = res.data.result.data.data;
          this.total = res.data.result.data.dataCount;
        }
      } else {
        this.$message.error(res.data.error.message)
      }
    },
    async export3() {
      ExportDistributionHasPaidOrderList(this.searchData).then(res => {
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' }) // res就是接口返回的文件流了
        let objectUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.download = '已付款订单列表.xlsx'  //后缀名一定要写对，不然会导致文件损坏，打不开
        a.href = objectUrl
        a.click()
        a.remove()
        console.log(res, '???????????')
      })
      // let res = await ExportDistributionHasPaidOrderList(this.searchData);
      // if (res.data.success) {
      //   this.$message.success('请前往下载中心查看！')
      // } else {
      //   this.$message.error(res.data.msg)
      // }
    },
    selectCurrentRow(val) {
      // this.currentRow = val;
    },
    handleCurrentChange(val) {
      this.searchData.PageIndex = val;
      this.getList();
    },
    handleSizeChange(e) {
      this.searchData.PageSize = e;
      this.getList();
    },
    searchFun() {
      // this.searchData = {
      //   PageIndex: 1, //页码
      //   PageSize: 10, //页长
      //   ChildOrderNo: null,
      //   SkuName: null,
      //   DistributorUserName: '',
      //   StartPayTime: null,
      //   EndPayTime: null,
      //   receivingName: null,
      //   Status: null,
      // };
      // this.getTableList();
      this.getList()
    },
    resetFun() {
      this.searchData = {
        ResellerId:null,
        PageIndex: 1, //页码
        PageSize: 10, //页长
        ChildOrderNo: null,
        SkuName: null,
        DistributorUserName: '',
        ChannelBusiness: '',
        StartPayTime: null,
        EndPayTime: null,
        receivingName: null,
        Status: null,
      };
      this.valueTime = [];
      // this.getTableList();
      this.getList();
    },
    handlePicker(e) {
      console.log('llllll', e)
      if (e == null) {
        this.valueTime = []
        this.searchData.CreationStartTime = null;
        this.searchData.CreationEndTime = null;
      } else {
        this.searchData.CreationStartTime = e[0];
        this.searchData.CreationEndTime = e[1];
      }
    },
  }
}
</script>


<style scoped>

</style>